/**
 * @mention choices for the composer. Bonnie is always offered; other people
 * come from the chat's member list. Matching is case-insensitive.
 */

export function mentionChoices(members, query) {
  const people = [{ name: 'Bonnie', id: 'bonnie', agent: true }];
  for (const member of members || []) {
    if (!member || member.is_agent || member.role === 'agent' || member.id === 'agent') continue;
    const name = String(member.name || member.email || '').trim().split(/\s+/)[0];
    if (!name) continue;
    people.push({ name, id: member.id, agent: false });
  }
  const q = String(query || '').toLowerCase();
  return people.filter((person) => person.name.toLowerCase().includes(q)).slice(0, 8);
}

/** Replace the @query at the caret with @Name and a trailing space. */
export function applyMention(value, caret, name) {
  const text = String(value || '');
  const at = Number.isFinite(caret) ? caret : text.length;
  const head = text.slice(0, at).replace(/@([A-Za-z0-9._-]*)$/, `@${name} `);
  return head + text.slice(at);
}
